export default "/images/vendor/flag-icon-css/flags/4x3/gm.svg?cdfdf8bcb862134ab9fe838e0a8c3fbb";